import * as Vuex from 'vuex';
import categories from '../modules/categories.js';
import demonstration from '../modules/demonstration.js';
import analysis from '../modules/analysis.js';
import deals from '../modules/deals.js';
import partners from '../modules/../modules/partners.js';

const store = Vuex.createStore({
  strict: process.env.NODE_ENV !== 'production',
});

store.registerModule('analysis', analysis);
store.registerModule('demonstration', demonstration);
store.registerModule('categories', categories);
store.registerModule('deals', deals);
store.registerModule('partners', partners);

export default store;
